import FlashcardPage from "./FlashcardPage";

class FlashcardActivityClass {
  constructor(config = {}) {
    this.activityId = config.activityId;
    this.activityMetaData = config.activityMetaData
      ? JSON.parse(config.activityMetaData)
      : {};
    this.flashcardPages = this.initFlashActivity(config.flashcardPages);
    this.usageAnalytics = this.parseAnalytics(config.usageAnalytics || []);
    this.isComplete = config.isComplete === true; // Learner property
    this.isMandatory = config.isMandatory !== false;
    this.isPublished = config.isPublished || false;
    this.isValid = config.isValid || false;
  }

  initFlashActivity(pageCollection = []) {
    return pageCollection.map(FlashcardPage);
  }

  getThemeBackgroundColor() {
    return this.activityMetaData.themeBackgroundColor || "white";
  }

  getThemeColor() {
    return this.activityMetaData.themeColor || "black";
  }

  getPreviewLayout() {
    return this.activityMetaData.previewLayout || "floating";
  }

  parseAnalytics(analyticsData) {
    let usageAnalytics = [];
    analyticsData.forEach(function(data) {
      if (data && data.length > 0) {
        usageAnalytics.push(JSON.parse(data));
      } else {
      }
    });
    return usageAnalytics;
  }

  isAllQuestionsAnswered(ignoreNonMandatory) {
      return this.flashcardPages
        .filter(page => !ignoreNonMandatory || page.isMandatory())
        .filter(page => {
          if(page.pageMetaData.isQuiz() && 
            page.pageMetaData.questionResponse && 
            !page.pageMetaData.questionResponse.isAnswered()) {
              return true;
          }
          return false;
        })
        .length === 0;
  }

  getAllQuestionResponses() {
    return this.flashcardPages
      .filter(page => page.isQuiz())
      .map(page => page.pageMetaData.questionResponse);
  }

  hasQuiz(){
    return this.flashcardPages.findIndex(page => page.isQuiz()) !== -1;
  }

  hasScore(){
    const questions = this.flashcardPages.filter(page => page.isQuiz());
    return questions.length > 0
        && questions.findIndex(page => page.pageMetaData.questionConfig.getScore() !== 0
                || page.pageMetaData.questionConfig.getNegativeScore() !== 0
        ) !== -1;
  }
}

const FlashcardActivity = config => new FlashcardActivityClass(config);
export default FlashcardActivity;
